import {FormLabelBannerEnum, FormLabelMechanicalEnum, FormLabelTitleEnum} from "./Form";
import {Price} from "../../../Types";

export enum PdfLabelTypeEnum {
  SIMPLE = "simple",
  ICON = "icon",
  CALCULATION = "calculation",
}

export type PdfLabelCommonType = {
  type: PdfLabelTypeEnum | null;
  mechanical: FormLabelMechanicalEnum;
  title: FormLabelTitleEnum | string;
  banner: FormLabelBannerEnum  | string;
  icon: string;
  name: string;
  format: string;
  details: string;
};

export const isPdfLabelSimpleType = (label: PdfLabelSimpleType | PdfLabelIconType | PdfLabelCalculationType): label is PdfLabelSimpleType => {
  return label.type === PdfLabelTypeEnum.SIMPLE;
};

export type PdfLabelSimpleType = PdfLabelCommonType & {
  discount: string;
  discountDetail: string | null;
};

export const isPdfLabelIconType = (label: PdfLabelSimpleType | PdfLabelIconType | PdfLabelCalculationType): label is PdfLabelIconType => {
  return label.type === PdfLabelTypeEnum.ICON;
};

export type PdfLabelIconType = PdfLabelCommonType & {
  icon: string;
  discountDetail: string;
};

export const isPdfLabelCalculationType = (label: PdfLabelSimpleType | PdfLabelIconType | PdfLabelCalculationType): label is PdfLabelCalculationType => {
  return label.type === PdfLabelTypeEnum.CALCULATION;
};

export type PdfLabelCalculationType = PdfLabelCommonType & {
  discountPrice: Price;
  discountUnitPrice: string | null;
  originalPrice: Price;
  originalUnitPrice: string | null;
  discountDetail: string | null;
};
